import { gql } from "graphql-tag"

const news = gql`
  type Mutation {
    addNews(news: NewsAddInput!): NewsAddResponse!
    addNewsSource(newsSourceAddInput: NewsSourceAddInput!): NewsSource!
    addPreviewNewsSource(
      previewNewsSourceAddInput: PreviewNewsSourceAddInput!
    ): PreviewNewsSource!
    addOutlet(
      outletAddInput: OutletAddInput!
      socialLinksAddInput: SocialLinksAddInput
    ): Outlet!

    deleteNews(id: ID!, cascadeHomeVideo: Boolean): DeleteResponse!
    deleteOutlet(id: ID!): DeleteResponse!

    generateDraftNews(
      generateDraftsInputs: [GenerateDraftNewsInput!]!
      options: GenerateDraftNewsInputOptions
    ): GenerateDraftNewsResponse!

    publishDraftNews(
      publishDraftsInputs: [PublishDraftNewsInput!]!
      options: PublishDraftNewsInputOptions
    ): PublishDraftNewsResponse!

    updateCriticsNewsSourcesFromUrl(
      id: ID!
      url: String!
      serviceName: String!
    ): NewsSourceResponse!
    updateNews(
      newsUpdateInput: NewsUpdateInput!
      options: NewsUpdateInputOptions
    ): NewsUpdateResponse!
    updateNewsSource(
      id: ID!
      newsSourceUpdateInput: NewsSourceUpdateInput!
    ): NewsSource!
    updateOutlet(id: ID!, outletUpdateInput: OutletUpdateInput!): Outlet!
  }
`

export default news
